/*
 * Copyright 2018 - 2021 Swiss Federal Institute of Technology Lausanne (EPFL)
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0.
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * This open source software code was developed in part or in whole in the
 * Human Brain Project, funded from the European Union's Horizon 2020
 * Framework Programme for Research and Innovation under
 * Specific Grant Agreements No. 720270, No. 785907, and No. 945539
 * (Human Brain Project SGA1, SGA2 and SGA3).
 *
 */

export const termsCurrentVersion = '2.2';

export const termsShortNotice = `
Access to the data and metadata provided through EBRAINS Knowledge Graph Data Platform (&quot;KG&quot;) requires that you cite and acknowledge said data and metadata according to the Terms and Conditions of the Platform.

- [Citation requirements](https://kg.ebrains.eu/search-terms-of-use.html?v=`+termsCurrentVersion+`#citations)

- These outlines are based on the authoritative [Terms and Conditions](https://kg.ebrains.eu/search-terms-of-use.html?v=`+termsCurrentVersion+`)

If you do not accept the Terms &amp; Conditions you are not permitted to access or use the KG to search for, to submit, to post, or to download any materials found there-in.
   
   
Our site saves small pieces of text information (cookies) on your device in order to deliver better content and for statistical purposes. You can disable the usage of cookies by changing the settings of your browser. By browsing our website without changing the browser settings you grant us permission to store that information on your device.

`;

export const termsShortNoticeUpdate = `
####We have updated the Terms and Conditions of the Platform!   
  
Please see the [change log](https://kg.ebrains.eu/search-terms-of-use.html?v=`+termsCurrentVersion+`#changelog) for what has changed.   

If you do not accept the Terms &amp; Conditions you are not permitted to access or use the KG to search for, to submit, to post, or to download any materials found there-in.
`;
